<template>
  <div class="container page">
    <van-nav-bar title="绑定银行卡" class="nav-bar" fixed placeholder><template #left><van-icon name="arrow-left" @click="back" /></template></van-nav-bar>
    <div class="main-box">
      <div class="section-tip">请准确填写银行卡资料</div>
      <div class="form-card"><van-cell-group :border="false">
        <van-field v-model.trim="bank" label="银行名称" placeholder="请输入银行名称" />
        <van-field v-model.trim="bankCode" label="银行代码" placeholder="请输入银行代码" />
        <van-field v-model.trim="bankid" label="银行账号" placeholder="请输入银行账号" />
        <van-field v-model.trim="username" label="持有人姓名" placeholder="请输入持有人姓名" />
        <div class="upload-row"><div class="upload-label">银行卡图片</div><van-uploader v-model="fileList" :max-count="1" :after-read="afterRead" accept="image/*" /></div>
      </van-cell-group></div>
      <p class="warn-text"><van-icon name="info-o" />请确保银行卡资料及图片清晰、真实、有效</p>
    </div>
    <van-button class="bind-card-btn" :loading="submitting" @click="bindCard">确认绑定</van-button>
  </div>
</template>
<script>
export default {
  data(){return{bank:'',bankCode:'',bankid:'',username:'',bankImage:'',fileList:[],submitting:false}},
  methods:{
    back(){window.history.back()},
    afterRead(file){
      if(file.file&&file.file.size>5*1024*1024){this.fileList=[];this.$toast.fail('图片不能超过5MB');return}
      file.status='uploading';file.message='处理中';
      const img=new Image();img.onload=()=>{
        const max=1200,scale=Math.min(1,max/Math.max(img.width,img.height)),canvas=document.createElement('canvas');
        canvas.width=Math.round(img.width*scale);canvas.height=Math.round(img.height*scale);
        canvas.getContext('2d').drawImage(img,0,0,canvas.width,canvas.height);
        this.bankImage=canvas.toDataURL('image/jpeg',.78);file.content=this.bankImage;file.status='done';file.message='';
      };img.onerror=()=>{this.fileList=[];this.$toast.fail('图片读取失败')};img.src=file.content;
    },
    bindCard(){
      if(!this.bank)return this.$toast.fail('请输入银行名称');
      if(!this.bankCode)return this.$toast.fail('请输入银行代码');
      if(!this.bankid)return this.$toast.fail('请输入银行账号');
      if(!this.username)return this.$toast.fail('请输入持有人姓名');
      if(!this.bankImage)return this.$toast.fail('请上传银行卡图片');
      this.submitting=true;
      this.$http({method:'post',url:'user_set_bank',data:{bank:this.bank,fhnumber:this.bankCode,bankid:this.bankid,username:this.username,bankfenhang:'',bank_image:this.bankImage}}).then(res=>{
        this.submitting=false;if(res.code===200){this.$toast.success(res.msg||'绑定成功');this.$router.push('/Setbank')}else this.$toast.fail(res.msg||'绑定失败')
      }).catch(()=>{this.submitting=false;this.$toast.fail('网络异常')})
    }
  },
  created(){if(!localStorage.getItem('token'))this.$router.replace('/Login')}
}
</script>
<style lang="less" scoped>
@import "../../assets/css/base.css";
.container{min-height:100vh;background:#f6f5f2}.nav-bar{background:linear-gradient(135deg,#7c6ff0,#db6ea9)}.nav-bar ::v-deep .van-nav-bar__title{color:#fff;font-size:34px;font-weight:700}.nav-bar ::v-deep .van-icon{color:#fff!important;font-size:38px!important}
.main-box{padding:30px 24px}.section-tip{padding:0 10px 20px;color:#8d8791;font-size:27px}.form-card{overflow:hidden;border-radius:22px;background:#fff;box-shadow:0 10px 26px rgba(45,35,65,.08)}.form-card ::v-deep .van-cell{padding:27px 28px;font-size:29px}.form-card ::v-deep .van-field__label{width:180px;color:#3d3742;font-weight:600}.form-card ::v-deep .van-field__control{font-size:27px}
.upload-row{display:flex;align-items:flex-start;padding:27px 28px}.upload-label{width:180px;padding-top:20px;color:#3d3742;font-size:29px;font-weight:600}.upload-row ::v-deep .van-uploader__upload,.upload-row ::v-deep .van-uploader__preview-image{width:150px;height:150px;border-radius:16px}.warn-text{display:flex;gap:10px;margin:28px 10px 0;color:#a09aa4;font-size:24px;line-height:1.5}.warn-text .van-icon{margin-top:4px;color:#9a73df;font-size:28px}
.bind-card-btn{width:calc(100% - 48px);height:88px;margin:24px;border:0;border-radius:44px;background:linear-gradient(135deg,#7c6ff0,#db6ea9);box-shadow:0 8px 20px rgba(124,111,240,.25);color:#fff;font-size:32px;font-weight:700}
</style>
